class Dropdown {
  constructor(elem) {
    this.dropdown = elem;
    this.link = this.dropdown.find('[data-dropdown-link]');
    this.inner = this.dropdown.find('[data-dropdown-inner]');
    this.sortBy = this.dropdown.find('[data-sort-by]');
  }

  initialize() {
    const that = this;

    this.link.on('click', function(e) {
      e.stopPropagation();
      that.dropdown.toggleClass('show');
      $(this).toggleClass('open');
    });

    this.sortBy.on('click', function(e) {
      that.setSelected($(this));
      that.dropdown.removeClass('show');
    });

    $('body').on('click', function() {
      that.dropdown.removeClass('show');
    });

    that.setSelected(this.dropdown.find('.active'));
    $(window).on('resize', function() {
      that.setResultsWidth()
    })
  }

  setSelected(activeElement) {
      if (!activeElement) {
          return;
      }

      const that = this;

      let value = activeElement.attr('data-sort-by');
      let text = activeElement.attr('data-sort-text');

      if (that.dropdown.is('[data-catalog-sort]')) {
          $('[data-catalog-sort]').each(function() {
              let _this = $(this);

              _this.find('[data-sort-by]').removeClass('active');

              _this.find('[data-sort-by]').each(function() {
                  if (activeElement.data('sort-by') === $(this).data('sort-by')) {
                      $(this).addClass('active');

                      return false;
                  }
              });

              _this.find('[data-dropdown-link]').attr('data-dropdown-link', value);
              _this.find('[data-dropdown-link]').text(text);

              that.setResultsWidth();
          });

      } else {
          that.sortBy.removeClass('active');
          activeElement.addClass('active');

          that.link.attr('data-dropdown-link', value);
          that.link.text(text);
      }
  }

  setResultsWidth() {
    const ww = $(window).width();
    const resultsContainer = this.dropdown.closest('[data-filter-container]').find('[data-catalog-results-container]');
    const filterContainer = this.dropdown.closest('[data-filter-container]').find('[data-catalog-filter-container]');
    const toolsContainer = this.dropdown.closest('[data-filter-container]').find('[data-catalog-tools-container]');
    let toolsPadding = parseFloat(toolsContainer.css('padding-right'));

    if (ww > 767) {
      let rowWidth = resultsContainer.parent().width();
      let resultsWidth = rowWidth - filterContainer.width() - toolsContainer.width() - 45 - toolsPadding;
      resultsContainer.css({'max-width': `${resultsWidth}px`})
    } else {
      resultsContainer.attr('style', '');
    }
  }
}

export {Dropdown}

$(window).on('load', function() {
  let dropdowns = [];

  if ($('[data-dropdown]').length > 0) {
    $('[data-dropdown]').each(function(i) {
      dropdowns[i] = new Dropdown($(this));
      dropdowns[i].initialize();
    });
  }
});